function pickSupportedMime() {
    const audioTypes = ["audio/ogg", "audio/wav", "audio/webm", "audio/mpeg", "audio/mp4"];
    for (let type of audioTypes) {
        if (MediaRecorder.isTypeSupported(type)) {
            return type;
        }
    }
    alert(
        "Your browser does not support any of the required audio formats. Please use a different browser."
    );
}
function fileExtensionFromMime(mime) {
    if (!mime) return "webm";
    if (mime.includes("mp4")) return "m4a";
    if (mime.includes("mpeg")) return "mp3";
    if (mime.includes("wav")) return "wav";
    if (mime.includes("ogg")) return "ogg";
    if (mime.includes("webm")) return "webm";
    return "webm";
}

function waitForEvent(target, event) {
    return new Promise((resolve) => {
        const handler = (e) => {
            target.removeEventListener(event, handler);
            resolve(e);
        };
        target.addEventListener(event, handler);
    });
}

export const startRecording = async ({ onChunk, timeslice, onStreamReady } = {}) => {
    try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        localStorage.setItem("audioPermission", "granted");

        // Call the callback with the stream if provided
        if (typeof onStreamReady === "function") {
            onStreamReady(stream);
        }

        const mimeType = pickSupportedMime();
        if (!mimeType) {
            return;
        }
        const mr = new MediaRecorder(stream, { mimeType: mimeType });

        const chunks = [];
        let startedAt = Date.now();

        mr.addEventListener("dataavailable", (e) => {
            if (e.data && e.data.size > 0) {
                chunks.push(e.data);
                if (typeof onChunk === "function") {
                    onChunk(e.data);
                }
            }
        });

        // start recording
        if (typeof timeslice === "number" && timeslice > 0) {
            mr.start(timeslice);
        } else {
            mr.start(50);
        }

        const controller = {
            stop: async () => {
                // stop recording
                if (mr.state !== "inactive") {
                    mr.stop();
                }
                // wait for MediaRecorder to fully stop
                if (mr.state !== "inactive") {
                    await waitForEvent(mr, "stop");
                }

                stream.getTracks().forEach((t) => t.stop());
                const blob = new Blob(chunks, { type: mimeType });
                const url = URL.createObjectURL(blob);

                const ext = fileExtensionFromMime(mimeType);
                const filename = `${crypto.randomUUID()}.${ext}`;
                const file = new File([blob], filename, { type: mimeType });
                const durationMs = Date.now() - startedAt - 100; // 100 ms for starting and stopping etc

                return { blob, file, url, mimeType, durationMs };
            },
            cancel: async () => {
                if (mr.state !== "inactive") {
                    mr.stop();
                    await waitForEvent(mr, "stop");
                }
                stream.getTracks().forEach((track) => track.stop());
                // discard any buffered chunks
                chunks.length = 0;
            },
            mimeType,
        };

        return controller;
    } catch (error) {
        // likely the user didn't allow audio recordings
        throw error;
    }
};
